import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';

interface ICellRendererParamsWithCustomProps extends ICellRendererParams {
  onChange?: (params: ICellRendererParams) => void;
  showToggle?: (params: ICellRendererParams) => boolean;
}

@Component({
    selector: 'app-cell-radio-button',
    imports: [FormsModule, CommonModule, MatSlideToggle],
    template: `@if (showToggle()) {
    <mat-slide-toggle [checked]="isChecked" (change)="onChange($event)" />
  } `
})
export class CellSlideToggleButtonComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParamsWithCustomProps;
  public isChecked = false;
  public showToggle = signal<boolean>(true);

  public agInit(params: ICellRendererParamsWithCustomProps): void {
    this.showToggle.set(params.showToggle?.(params) ?? false);
    this.params = params;
    this.isChecked = params.value; // Set the initial checked state based on the cell value
  }

  public refresh(params: ICellRendererParamsWithCustomProps): boolean {
    this.isChecked = params.value;
    return true;
  }

  protected onChange(event: MatSlideToggleChange): void {
    this.isChecked = event.checked;
    this.params?.onChange?.({ ...this.params, data: { ...this.params.data, isOutOfService: this.isChecked } }); // Update the cell value
  }
}
